import styles from './icon-circle.module.scss';

export const IconCircle = ({ Icon, size = 'default', color }) => {
  return (
    <div className={`${styles.iconContainer} ${styles[size]} ${styles[color]}`}>
      <Icon className={`${styles.icon}`} />
    </div>
  );
};
